export enum DiscountSegmentationEnum {
  ALL = "ALL",
  FIRST_ORDERS = "FIRST_ORDERS",
}
